export const MDY_DEV = typeof __MDY_DEV__ === "undefined" || __MDY_DEV__;
